import { config } from "config"
import { Account, AddClaimsForUsersRequest, AdminAccessRequest, RemoveUsersRequest, ServiceSummary, UpdateUserRequest, User } from "data/interfaces"
import { HttpService } from "./HttpService"


export class ApiService {

    private static http = (): HttpService => new HttpService(config.apiUrl)
  
    static async getAccounts() {
      return this.http().get<Account[]>(`/accounts`)
    }

    static async getAccount(accountId: string) {
      return this.http().get<Account>(`/accounts/${accountId}`)
    }

    static async setAdminAccess(accountId: string, userEmails: string[], isAdmin: boolean) {
      return this.http().put(`/accounts/${accountId}/admins`, { users: userEmails, adminAccess: isAdmin } as AdminAccessRequest)
    }

    static async getServices(accountId: string) {
      return this.http().get<ServiceSummary[]>(`/accounts/${accountId}/licenses/summary`)
    }

    static async getUsers(accountId: string) {
      return this.http().get<User[]>(`/accounts/${accountId}/users`)
    }

    static async AddUsers(accountId: string, users: string[]) {
      return this.http().post<User[]>(`/accounts/${accountId}/users`, users)
    }

    static async removeUsers(accountId: string, removeUsersRequest: RemoveUsersRequest) {
      return this.http().delete(`/accounts/${accountId}/users`, removeUsersRequest)
    }

    static async AddUsersByCsv(accountId: string, formData: FormData) {
      return this.http().postForm<User[]>(
        `/accounts/${accountId}/users/csv`,
        formData
      );
    }

    static async updateClaimsFor(accountId: string, updateRequests: UpdateUserRequest[]) {
      return this.http().post<ServiceSummary[]>(`/accounts/${accountId}/users/claims`, updateRequests)
    }

    static async addClaimsForUsers(accountId: string, addClaimsRequest: AddClaimsForUsersRequest) {
      return this.http().post<ServiceSummary[]>(`/accounts/${accountId}/users/multiple/claims`, addClaimsRequest)
    }

    static async getMagiCloudUsers(accountId: string, emails: string[]) {
      return this.http().post<User[]>(`/accounts/${accountId}/candidates`, emails)
  }
}